
import React from 'react';

import TextField from '../../../../forms/TextField';

export default function AdParameters() {
  return(
    <TextField
      name="videoAd.adParameters"
      label='VPAID Ad Parameters'
      multiline
      rows={5}
    />
  )
}
